import { useMemo } from 'react';
import { type SupportedLocale } from '@zep-us/i18n';

import { type SelectOption } from '@/ui_v3/components/select/type';

import { NATIVE_LANGUAGE_LIST } from '../supportedLanguages';

export function useLanguageOptions(): SelectOption<SupportedLocale>[] {
  return useMemo(
    () =>
      NATIVE_LANGUAGE_LIST.map(language => ({
        value: language.locale,
        label: language.nativeName + ` (${language.locale})`,
      })),
    [],
  );
}
